var map = {
	"./eduqasAuthors": [
		9914,
		9914
	],
	"./eduqasAuthors.json": [
		9914,
		9914
	],
	"./eduqasSubjects": [
		323,
		323
	],
	"./eduqasSubjects.json": [
		323,
		323
	],
	"./eduqasSubjects/Applied-Science-EN": [
		630,
		630
	],
	"./eduqasSubjects/Applied-Science-EN.json": [
		630,
		630
	],
	"./eduqasSubjects/Art-and-Design-EN": [
		5350,
		5350
	],
	"./eduqasSubjects/Art-and-Design-EN.json": [
		5350,
		5350
	],
	"./eduqasSubjects/Biology-EN": [
		4222,
		4222
	],
	"./eduqasSubjects/Biology-EN.json": [
		4222,
		4222
	],
	"./eduqasSubjects/Business-EN": [
		5882,
		5882
	],
	"./eduqasSubjects/Business-EN.json": [
		5882,
		5882
	],
	"./eduqasSubjects/Chemistry-EN": [
		77,
		77
	],
	"./eduqasSubjects/Chemistry-EN.json": [
		77,
		77
	],
	"./eduqasSubjects/Computer-Science-EN": [
		3287,
		3287
	],
	"./eduqasSubjects/Computer-Science-EN.json": [
		3287,
		3287
	],
	"./eduqasSubjects/Design-and-Technology-EN": [
		8508,
		8508
	],
	"./eduqasSubjects/Design-and-Technology-EN.json": [
		8508,
		8508
	],
	"./eduqasSubjects/Drama-EN": [
		7996,
		7996
	],
	"./eduqasSubjects/Drama-EN.json": [
		7996,
		7996
	],
	"./eduqasSubjects/English-Language---Literature-EN": [
		2088,
		2088
	],
	"./eduqasSubjects/English-Language---Literature-EN.json": [
		2088,
		2088
	],
	"./eduqasSubjects/English-Language-EN": [
		3083,
		3083
	],
	"./eduqasSubjects/English-Language-EN.json": [
		3083,
		3083
	],
	"./eduqasSubjects/English-Language-Literature-EN": [
		2297,
		2297
	],
	"./eduqasSubjects/English-Language-Literature-EN.json": [
		2297,
		2297
	],
	"./eduqasSubjects/English-Literature-EN": [
		4768,
		4768
	],
	"./eduqasSubjects/English-Literature-EN.json": [
		4768,
		4768
	],
	"./eduqasSubjects/Geography-EN": [
		2568,
		2568
	],
	"./eduqasSubjects/Geography-EN.json": [
		2568,
		2568
	],
	"./eduqasSubjects/History-EN": [
		1038,
		1038
	],
	"./eduqasSubjects/History-EN.json": [
		1038,
		1038
	],
	"./eduqasSubjects/Mathematics-EN": [
		5727,
		5727
	],
	"./eduqasSubjects/Mathematics-EN.json": [
		5727,
		5727
	],
	"./eduqasSubjects/Physics-EN": [
		4324,
		4324
	],
	"./eduqasSubjects/Physics-EN.json": [
		4324,
		4324
	],
	"./eduqasSubjects/Psychology-EN": [
		3840,
		3840
	],
	"./eduqasSubjects/Psychology-EN.json": [
		3840,
		3840
	],
	"./eduqasSubjects/Religious-Studies-EN": [
		3851,
		3851
	],
	"./eduqasSubjects/Religious-Studies-EN.json": [
		3851,
		3851
	],
	"./wjecAuthors": [
		2106,
		2106
	],
	"./wjecAuthors.json": [
		2106,
		2106
	],
	"./wjecSubjects": [
		8927,
		8927
	],
	"./wjecSubjects.json": [
		8927,
		8927
	],
	"./wjecSubjects/Applied-Science-EN": [
		1809,
		1809
	],
	"./wjecSubjects/Applied-Science-EN.json": [
		1809,
		1809
	],
	"./wjecSubjects/Art-and-Design-EN": [
		5619,
		5619
	],
	"./wjecSubjects/Art-and-Design-EN.json": [
		5619,
		5619
	],
	"./wjecSubjects/Astudiaethau-Crefyddol-CY": [
		1918,
		1918
	],
	"./wjecSubjects/Astudiaethau-Crefyddol-CY.json": [
		1918,
		1918
	],
	"./wjecSubjects/Bioleg-CY": [
		5336,
		5336
	],
	"./wjecSubjects/Bioleg-CY.json": [
		5336,
		5336
	],
	"./wjecSubjects/Biology-EN": [
		1010,
		1010
	],
	"./wjecSubjects/Biology-EN.json": [
		1010,
		1010
	],
	"./wjecSubjects/Business-EN": [
		3561,
		3561
	],
	"./wjecSubjects/Business-EN.json": [
		3561,
		3561
	],
	"./wjecSubjects/Busnes-CY": [
		9558,
		9558
	],
	"./wjecSubjects/Busnes-CY.json": [
		9558,
		9558
	],
	"./wjecSubjects/Celf-a-Dylunio-CY": [
		906,
		906
	],
	"./wjecSubjects/Celf-a-Dylunio-CY.json": [
		906,
		906
	],
	"./wjecSubjects/Cemeg-CY": [
		7719,
		7719
	],
	"./wjecSubjects/Cemeg-CY.json": [
		7719,
		7719
	],
	"./wjecSubjects/Chemistry-EN": [
		8026,
		8026
	],
	"./wjecSubjects/Chemistry-EN.json": [
		8026,
		8026
	],
	"./wjecSubjects/Computer-Science-EN": [
		6733,
		6733
	],
	"./wjecSubjects/Computer-Science-EN.json": [
		6733,
		6733
	],
	"./wjecSubjects/Cyfrifiadureg-CY": [
		4792,
		4792
	],
	"./wjecSubjects/Cyfrifiadureg-CY.json": [
		4792,
		4792
	],
	"./wjecSubjects/Cymraeg-Ail-Iaith-CY": [
		2290,
		2290
	],
	"./wjecSubjects/Cymraeg-Ail-Iaith-CY.json": [
		2290,
		2290
	],
	"./wjecSubjects/Cymraeg-CY": [
		2469,
		2469
	],
	"./wjecSubjects/Cymraeg-CY.json": [
		2469,
		2469
	],
	"./wjecSubjects/Daearyddiaeth-CY": [
		4813,
		4813
	],
	"./wjecSubjects/Daearyddiaeth-CY.json": [
		4813,
		4813
	],
	"./wjecSubjects/Design-and-Technology-EN": [
		4373,
		4373
	],
	"./wjecSubjects/Design-and-Technology-EN.json": [
		4373,
		4373
	],
	"./wjecSubjects/Drama-EN": [
		8872,
		8872
	],
	"./wjecSubjects/Drama-EN.json": [
		8872,
		8872
	],
	"./wjecSubjects/Dylunio-a-Thechnoleg-CY": [
		9850,
		9850
	],
	"./wjecSubjects/Dylunio-a-Thechnoleg-CY.json": [
		9850,
		9850
	],
	"./wjecSubjects/English-Language-EN": [
		10,
		10
	],
	"./wjecSubjects/English-Language-EN.json": [
		10,
		10
	],
	"./wjecSubjects/English-Language-Literature-EN": [
		4281,
		4281
	],
	"./wjecSubjects/English-Language-Literature-EN.json": [
		4281,
		4281
	],
	"./wjecSubjects/English-Literature-EN": [
		6564,
		6564
	],
	"./wjecSubjects/English-Literature-EN.json": [
		6564,
		6564
	],
	"./wjecSubjects/Ffiseg-CY": [
		8216,
		8216
	],
	"./wjecSubjects/Ffiseg-CY.json": [
		8216,
		8216
	],
	"./wjecSubjects/Geography-EN": [
		2582,
		2582
	],
	"./wjecSubjects/Geography-EN.json": [
		2582,
		2582
	],
	"./wjecSubjects/Gwyddoniaeth-Gymhwysol-CY": [
		6300,
		6300
	],
	"./wjecSubjects/Gwyddoniaeth-Gymhwysol-CY.json": [
		6300,
		6300
	],
	"./wjecSubjects/Hanes-CY": [
		3557,
		3557
	],
	"./wjecSubjects/Hanes-CY.json": [
		3557,
		3557
	],
	"./wjecSubjects/History-EN": [
		883,
		883
	],
	"./wjecSubjects/History-EN.json": [
		883,
		883
	],
	"./wjecSubjects/Mathemateg-CY": [
		6899,
		6899
	],
	"./wjecSubjects/Mathemateg-CY.json": [
		6899,
		6899
	],
	"./wjecSubjects/Mathematics-EN": [
		8281,
		8281
	],
	"./wjecSubjects/Mathematics-EN.json": [
		8281,
		8281
	],
	"./wjecSubjects/Physics-EN": [
		352,
		352
	],
	"./wjecSubjects/Physics-EN.json": [
		352,
		352
	],
	"./wjecSubjects/Psychology-EN": [
		7603,
		7603
	],
	"./wjecSubjects/Psychology-EN.json": [
		7603,
		7603
	],
	"./wjecSubjects/Religious-Studies-EN": [
		1541,
		1541
	],
	"./wjecSubjects/Religious-Studies-EN.json": [
		1541,
		1541
	],
	"./wjecSubjects/Saesneg-CY": [
		4295,
		4295
	],
	"./wjecSubjects/Saesneg-CY.json": [
		4295,
		4295
	],
	"./wjecSubjects/Seicoleg-CY": [
		8340,
		8340
	],
	"./wjecSubjects/Seicoleg-CY.json": [
		8340,
		8340
	],
	"./wjecSubjects/Welsh-EN": [
		3599,
		3599
	],
	"./wjecSubjects/Welsh-EN.json": [
		3599,
		3599
	],
	"./wjecSubjects/Welsh-Second-Language-EN": [
		6705,
		6705
	],
	"./wjecSubjects/Welsh-Second-Language-EN.json": [
		6705,
		6705
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3159;
module.exports = webpackAsyncContext;